import { render } from "./PublicationAiGenerate.vue?vue&type=template&id=ee8b925a"
import script from "./PublicationAiGenerate.vue?vue&type=script&lang=js"
export * from "./PublicationAiGenerate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__